import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { HBox, VBox } from '../../../../components/Box';
import { Cell as ActionCell } from '../Cell';
import { selectVehicle } from '../../../Vehicles/selectors';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { fetchInvoice } from '../../../Invoices/actions';
import { VehicleHeaderV2Design } from '../../../Vehicles/components/VehicleHeaderV2Design';
import { fetchCompany } from '../../../Companies/actions';
import { FINCompanyCard } from '../../../Companies/components/FinCompanyCard';
import { Button } from '../../../../components/Buttons';
import { generateIncomingInvoice } from '../../../Vehicles/actions';
import { performAction, toggleKanbanCompanyModal } from '../../actions';
import { selectKanbanCompanyToggle } from '../../selectors';
import { SideModal } from '../../components/SideModal';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_GENERATE_INCOMING_INVOICE } from '../../../Vehicles/constants';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
const Container = styled.div`

  box1 {
    h2 {
      font-size: 16px;
      text-transform: uppercase;
    }
`;


//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const STATE = {
  approve: false,
  value: '',
  'testdrive-data': false,
};

/* eslint-disable react/prefer-stateless-function */
class WIENTJES_FIN_process_purchaseComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    // this.props.fetchCompany(this.vehicle?.creditor_company);
  }

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  renderAttachedIncomingInvoice() {
    return this.vehicle?.incoming_invoice ? (
      <Link onClick={this.tofn(`/invoices/incoming/${this.props.vehicle?.incoming_invoice}`)}>
        {this.lbl('vehicle.details.showInvoice')} (id - {this.props.vehicle?.incoming_invoice}))
      </Link>
    ) : (
      <Button
        small
        disabled={this.vehicle?.incoming_invoice_in_helga === '1'}
        onClick={() =>
          this.props.generateIncomingInvoice(res => {
            if (res?.id) {
              this.props.confirm(this.vehicle, () => this.props.onCloseModal());
            }
          })
        }
      >
        {this.lbl('vehicle.details.create_invoice')}
      </Button>
    );
  }

  toggle() {
    return this.props.toggleModal(this.vehicle?.id);
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <ActionCell>
        <Container>
          {this.props.isShowModal?.isShow && this.props.isShowModal?.entityId == vehicle?.id && (
            <SideModal>
              <WithVehicle vehicle_id={this.props.cell.vehicle.id} loader>
                <VBox className={`${this.props.fullFetch ? 'loading' : ''}`} key="body">
                  {this.props.work ? (
                    <Loader small />
                  ) : (
                    <HBox className="box1" vCenter>
                      <h2>{this.props.action?.functionName}</h2>
                      {this.renderAttachedIncomingInvoice()}
                    </HBox>
                  )}
                  <VehicleHeaderV2Design wide vehicle={this.vehicle} />
                  <FINCompanyCard companyId={this.vehicle?.creditor_company} />
                </VBox>
              </WithVehicle>
            </SideModal>
          )}
          <VehicleHeader vehicle={vehicle} />
          <Label count={vehicle?.doorlooptijd_inkoop_verwerken_na_document_inkoop_toegevoegd_counter} ranges={ranges}>
            {vehicle?.doorlooptijd_inkoop_verwerken_na_document_inkoop_toegevoegd_counter || '0'}

          </Label>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton onClick={this.toggle.bind(this)}>
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
      </ActionCell>
    );
  }
}

WIENTJES_FIN_process_purchaseComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    isShowModal: selectKanbanCompanyToggle(),
    work: selectWork(REQUEST_GENERATE_INCOMING_INVOICE),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchInvoice(invoiceId) {
      dispatch(fetchInvoice(invoiceId));
    },
    fetchCompany(companyId) {
      dispatch(fetchCompany(companyId));
    },
    generateIncomingInvoice(callback) {
      dispatch(generateIncomingInvoice(ownProps.cell?.vehicle?.id, callback));
    },
    toggleModal(vehicleId) {
      dispatch(toggleKanbanCompanyModal(vehicleId));
    },
    confirm(vehicle, callback) {
      dispatch(performAction(ownProps.action?.id, vehicle?.id, { regplate_code: vehicle?.regplate_code || '' }, callback));
    },
    onCloseModal() {
      dispatch(toggleKanbanCompanyModal());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WIENTJES_FIN_process_purchase = compose(withConnect, withRouter)(WIENTJES_FIN_process_purchaseComp);
